<template>
  <div class="detail-skeleton">
    <div class="detail-skeleton__header">
      <div class="skeleton-shimmer" style="width: 65%; max-width: 320px; height: 22px; border-radius: 6px;"></div>
      <div class="detail-skeleton__date">
        <div class="skeleton-shimmer" style="width: 16px; height: 16px; border-radius: 4px;"></div>
        <div class="skeleton-shimmer" style="width: 130px; height: 14px;"></div>
      </div>
    </div>
    <div class="skeleton-shimmer detail-skeleton__divider"></div>
    <div class="detail-skeleton__body">
      <div class="skeleton-shimmer" style="width: 100%; height: 14px; margin-bottom: 12px;"></div>
      <div class="skeleton-shimmer" style="width: 90%; height: 14px; margin-bottom: 12px;"></div>
      <div class="skeleton-shimmer" style="width: 95%; height: 14px; margin-bottom: 12px;"></div>
      <div class="skeleton-shimmer" style="width: 60%; height: 14px; margin-bottom: 24px;"></div>
      <div class="skeleton-shimmer" style="width: 85%; height: 14px; margin-bottom: 12px;"></div>
      <div class="skeleton-shimmer" style="width: 70%; height: 14px;"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotificationDetailSkeleton",
};
</script>

<style scoped>
@keyframes skeleton-shimmer-anim {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

.skeleton-shimmer {
  display: block;
  border-radius: 4px;
  background: linear-gradient(90deg, #eee 25%, #e5e5e5 50%, #eee 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer-anim 1.5s infinite;
}

.detail-skeleton {
  display: flex;
  flex-direction: column;
}

.detail-skeleton__header {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.detail-skeleton__date {
  display: flex;
  align-items: center;
  gap: 6px;
}

.detail-skeleton__divider {
  height: 1px;
  width: 100%;
  margin: 20px 0;
  border-radius: 0;
}

.detail-skeleton__body {
  display: flex;
  flex-direction: column;
}
</style>
